import { useMantineColorScheme } from "@mantine/core";
import { createStyles, rem } from "@mantine/styles";

export const useStyles = createStyles((theme) => {
  const BREAKPOINT = theme.breakpoints.sm;
  const { colorScheme } = useMantineColorScheme();

  return {
    wrapper: {
      display: "flex",
      //   backgroundColor:
      //     theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.white,
      borderRadius: theme.radius.lg,
      padding: rem(4),
      //   border: `1px solid ${
      //     theme.colorScheme === "dark"
      //       ? theme.colors.dark[8]
      //       : theme.colors.gray[2]
      //   }`,

      [`@media (max-width: ${BREAKPOINT})`]: {
        flexDirection: "column",
      },
      h2: {
        fontSize: "150px!important",
      },
    },

    form: {
      boxSizing: "border-box",
      flex: 1,
      padding: theme.spacing.xl,
      paddingLeft: rem(parseFloat(theme.spacing.xl) * 2),
      borderLeft: 0,

      [`@media (max-width: ${BREAKPOINT})`]: {
        padding: theme.spacing.md,
        paddingLeft: theme.spacing.md,
      },
    },

    fields: {
      marginTop: rem(-12),
    },

    fieldInput: {
      flex: 1,

      "& + &": {
        marginLeft: theme.spacing.md,

        [`@media (max-width: ${BREAKPOINT})`]: {
          marginLeft: 0,
          marginTop: theme.spacing.md,
        },
      },
    },

    fieldsGroup: {
      display: "flex",

      [`@media (max-width: ${BREAKPOINT})`]: {
        flexDirection: "column",
      },
    },

    contacts: {
      boxSizing: "border-box",
      position: "relative",
      borderRadius: theme.radius.lg,
      backgroundColor: `${colorScheme === "light" ? "#B5262E" : "#2e2e2e"}`,

      backgroundSize: "cover",
      backgroundPosition: "center",
      border: "1px solid transparent",
      padding: theme.spacing.xl,
      flex: "0 0 280px",
      marginRight: "20px",

      [`@media (max-width: ${BREAKPOINT})`]: {
        marginBottom: theme.spacing.sm,
        paddingLeft: theme.spacing.md,
      },
    },

    title: {
      marginBottom: `30px!important`,
      [`@media (max-width: ${BREAKPOINT})`]: {
        marginBottom: theme.spacing.xl,
      },
    },

    control: {
      //   backgroundColor: "#F7931D",

      [`@media (max-width: ${BREAKPOINT})`]: {
        flex: 1,
      },
    },
  };
});
